import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { HANDLE_BORDER_WIDTH } from '@/components/app/editor/selection-chrome/selection-chrome-constants'
import { chromeGeometry } from '@/lib/shapes/selection-chrome-preview'
import { selectionChromeFrameOfShape } from '@/lib/shapes/shape-coordinates'

import { formatPolygonPoints } from '../helpers/chrome-points'

/**
 * Opacity of the per-member outlines drawn inside a multi-selection — faint enough to read as a
 * secondary indicator beneath the group frame.
 */
const MEMBER_OUTLINE_OPACITY = 0.7

/**
 * One outline per member of a multi-selection, so each object reads as individually selected
 * under the group frame. Previously a CSS `border: 1px` on a div *inside* the zoom-scaled
 * canvas, which meant the "1px" was multiplied by zoom — hairline when zoomed out, heavy when
 * zoomed in. Here it is a real screen pixel, and it follows each member's own rotated visual
 * box rather than a measured `getBBox`.
 */
export function ChromeMemberOutlines({
  selected,
  scale,
  strokeColor,
}: {
  selected: ShapeData[]
  scale: number
  strokeColor: string
}) {
  return (
    <>
      {selected.map((shape) => (
        <polygon
          key={`member-${shape.id}`}
          points={formatPolygonPoints(
            chromeGeometry(selectionChromeFrameOfShape(shape), {
              scale,
              devicePixelSnap: true,
            }).corners
          )}
          fill="none"
          stroke={strokeColor}
          strokeWidth={HANDLE_BORDER_WIDTH}
          opacity={MEMBER_OUTLINE_OPACITY}
          style={{ pointerEvents: 'none' }}
        />
      ))}
    </>
  )
}
